// @flow

// NOTE:
// app/models/resolution_category.rbの定義を参照
// 以下配列内の数字は、上記ファイルで定義されているdataのid
export const RESOLUTION_CHOICE_CATEGORY = [2, 3, 4, 5, 14, 15];
export const RESOLUTION_OTHER_CATEGORY = [11, 12];
export const RESOLUTION_CLASS_STOCK_CATEGORY = [47, 48, 65, 67];
export const RESOLUTION_RELATED_SO_CATEGORY = [16, 43, 59];
